<template>
  <BittsModal
    title="Set your sharing settings"
    :use-mask-to-close="true"
    @closed="handleClose"
    @action="handleSave"
  >
    <template #header>
      <div>
        <h3 class="title"> Set your sharing settings </h3>
        <p class="description">
          Define which accounts and fields to share with new partners.<br />
          You can fine-tune these settings for each partner later.
        </p>
      </div>
    </template>
    <SharingSettingsTab ref="sharingSettingsTabRef" class="m-0" />
  </BittsModal>
  <router-view-wrapper />
</template>

<script setup lang="ts">
import { BittsModal } from '@crossbeam/bitts';

import { ref } from 'vue';
import { useRouter } from 'vue-router';

import SharingSettingsTab from '@/components/partners/DataSharingSettings/SettingsModal/SharingSettingsTab/components/SharingSettingsTab.vue';

import useNewOnboarding from '@/composables/useNewOnboarding';
import { StepType } from '@/constants/onboarding';
import { useDataSharesStore } from '@/stores';

const { handleChangeActiveStep } = useNewOnboarding();
const router = useRouter();

const sharingSettingsTabRef = ref<InstanceType<
  typeof SharingSettingsTab
> | null>(null);

function handleClose() {
  router.push({ name: 'onboarding' });
}

async function handleSave() {
  const success = await sharingSettingsTabRef.value?.triggerBulkUpdate();
  if (success) {
    await useDataSharesStore().refreshDataSharesStore();
    handleChangeActiveStep(StepType.Uncover);
    handleClose();
  }
}
</script>

<style lang="pcss" scoped>
@reference "../../../css/theme.css";
.title {
  @apply text-neutral-text-strong font-bold text-xl text-center w-full mb-8;
}
.description {
  @apply text-neutral-text text-m text-center ml-24 mb-24;
}
</style>
